<template>
  <div id="postInfo">
    <router-link :to="{path: `/life/${slug}`}" @click="goToArticle(slug)">
      <div class="img" :style="{backgroundImage:  `url('${image}')`}"></div>
      <h3 v-text="title"></h3>
      <div class="info">
        <div class="date">
          <mu-icon value="watch_later" color="#5b617c" />
          <time :datetime="time" v-text="moment(time).fromNow()"></time>
        </div>
        <div class="favourites">
          <mu-icon value="favorite" color="#d83e38" />
          <span v-text="favourites"></span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "LifePostInfo",
    props: {
      image: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      time: {
        type: String,
        required: true
      },
      favourites: {
        type: String,
        required: true
      },
      slug: {
        type: String,
        required: true
      }
    },
    methods: {
      goToArticle(slug) {
        let self = this;
        if (self.$store.state.status.payment.paid) {
          self.$router.push({
            name: 'LifeStyleArticle',
            params: {
              permalink: slug
            }
          });
        } else {
          self.$EventBus.$emit('App::triggerPaywall', true);
        }
      },
      moment(date) {
        return moment(date);
      },
    }
  }
</script>

<style scoped lang="less">
  #postInfo {
    margin: 0 0 24px;
    transition: .2s ease-in-out;
    cursor: pointer;
    &:hover {
      transform: translate(0,-2px);
    }
    .img {
      margin: 0;
      height: 160px;
      overflow: hidden;
      border-radius: 8px 8px 1.5rem;
      background-position: center center;
      background-size: cover;
    }
    h3 {
      font-size: 1.1rem;
      line-height: 1.4;
      margin: 14px 0 10px;
      color: #0179d5;
      cursor: pointer;
      font-weight: 600;
    }
    .info {
      display: flex;
      flex-direction: row;
      .date {
        color: #5b617c;
        i {
          vertical-align: bottom;
        }
        time {
          font-size: 1rem;
          font-weight: 500;
          color: #5b617c;
        }
      }
      .favourites {
        margin-left: 12px;
        i {
          vertical-align: bottom;
        }
        span {
          font-size: 1rem;
          font-weight: 500;
          color: #5b617c;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// LifePostInfo.vue?02c2e919